import _ from "lodash"
import { useEffect } from "react"
import { startOfMonth, endOfMonth, format } from "date-fns"
import useGlobalContext from "~/view-data/use-global-context"
import useFetch from "~/view-data/use-fetch"
import useHeader from "~/view-data/use-header"
import { showMessage } from "~/helper"
import api from "~/services/api"

const initialState = {
  loading: false,
  formLoading: false,
  term: null,
  offset: 0,
  model: null,
  data: { rows: [], count: 0, offset: 0 },
  showCovidModal: false,
}

const initialFilterState = {
  eventDateStart: startOfMonth(new Date()),
  eventDateEnd: endOfMonth(new Date()),
  offset: 0,
}

const useBlacklists = () => {
  const {
      state: {
        reportEvent = initialState,
        reportEventFilter = initialFilterState,
      },
      dispatch,
    } = useGlobalContext(),
    { state: headerState, actions: headerActions } = useHeader()

  useEffect(() => {
    headerActions.hideFilter()
    headerActions.callFilter(reportEventFilter)
    dispatch({ type: "reportEvent", payload: initialState })
    // eslint-disable-next-line
  }, [])

  const { data } = useFetch(
    {
      url: "report-event/list",
      method: "POST",
      params: {
        ..._.get(headerState, "filter.data"),
        offset: reportEvent.offset || 0,
      },
    },
    { revalidateIfStale: false, revalidateOnFocus: false }
  )

  useEffect(() => {
    headerActions.configure({
      title: "Relatório - Colaboradores do Evento",
      count: _.get(data, "count", 0),
      useFilter: true,
      loading: _.get(reportEvent, "loading", false),
      onSearch: (text) => list(0, text),
    })
    // eslint-disable-next-line
  }, [data, reportEvent])

  const failure = (error) => {
    dispatch({ type: "reportEvent", payload: { loading: false } })
    showMessage("error", error)
  }

  const list = (params) => {
    headerActions.callFilter({ ...params })
  }

  const pageChange = (offset = 0) => {
    dispatch({ type: "reportEvent", payload: { offset } })
  }

  const changeFilter = (data) => {
    dispatch({ type: "reportEvent", payload: { offset: 0 } })
    dispatch({ type: "reportEventFilter", persistent: true, payload: data })
    headerActions.callFilter({ ...data })
  }

  const downloadXlsx = async () => {
    dispatch({ type: "reportEvent", payload: { loading: true } })

    try {
      let params = _.get(headerState, "filter.data"),
        response = await api.get(`report-event/export-xlsx`, {
          responseType: "blob",
          params,
        }),
        filename = `relatorio-${format(new Date(), "dd-MM-yyyy")}.xlsx`
      api.download(response, filename)

      dispatch({ type: "reportEvent", payload: { loading: false } })
    } catch (error) {
      failure(error)
    }
  }

  const hideForm = async () => {
    headerActions.hideFilter()
  }

  const openCovidModal = (modalData) => {
    const person = _.get(modalData, "person") || {}
    dispatch({
      type: "reportEvent",
      payload: {
        modalPCovidData: { employee: { person } },
        showCovidModal: true,
      },
    })
  }

  const closeCovidModal = () => {
    dispatch({
      type: "reportEvent",
      payload: { modalPCovidData: {}, showCovidModal: false },
    })
  }

  const listSuppliers = async (term, callback) => {
    try {
      const response = await api.get(`events/list-suppliers`, {
        params: { term },
      })
      callback(response.data)
    } catch (error) {
      failure(error, dispatch)
    }
  }

  const listEvents = async (term, callback) => {
    try {
      const response = await api.get(`events/list-events`, {
        params: { term },
      })
      callback(response.data)
    } catch (error) {
      failure(error, dispatch)
    }
  }

  return {
    state: {
      ...reportEvent,
      data: data || { rows: [], count: 0, offset: 0 },
      loading: !data,
    },
    actions: {
      list,
      pageChange,
      changeFilter,
      downloadXlsx,
      hideForm,
      openCovidModal,
      closeCovidModal,
      listEvents,
      listSuppliers,
    },
  }
}

export default useBlacklists
